'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class NavbarComponent 
{
	constructor(Auth, $translate, $http)
	{
		'ngInject';

		this.isLoggedIn = Auth.isLoggedInSync;
		this.isOrganizer = Auth.isOrganizerSync;
		this.isChampOrganizer = Auth.isChampOrganizerSync;
		this.getCurrentUser = Auth.getCurrentUserSync;

		this.translate = $translate;
		this.isCollapsed = true;

		this.racesCount = null;
		this.resultsCount = null;
		this.champsCount = null;
		this.myEventsCount = null;
		this.myChampsCount = null;

		this.menu = [{
				title: 'HOME',
				icon: 'fa-home',
				state: 'home',
				show: 'showHelper'
			},{
				title: 'RACES',
				icon: 'fa-road',
				state: 'futureevents',
				show: 'showHelper'
			},{
				title: 'RESULTS',
				icon: 'fa-star',
				state: 'concludedevents',
				show: 'showHelper'
			},{
				title: 'CHAMPS',
				icon: 'fa-trophy',
				state: 'champs',
				show: 'showHelper'
			},{
				title: 'MYPANEL',
				icon: 'fa-dashboard',
				state: 'mypanel',
				show: 'isLoggedIn'
			},{
				title: 'MYEVENTS',
				icon: 'fa-calendar',
				state: 'myevents',
				show: 'isOrganizer'
			},{
				title: 'MYCHAMPS',
				icon: 'fa-calendar',
				state: 'mychamps',
				show: 'isChampOrganizer'
			}
		];

		$http.post("/api/frontend/events/totals")
		.then(response => {
			this.menu[1].count = response.data.newevents;
			this.menu[2].count = response.data.oldevents;
			this.menu[3].count = response.data.champs;
			this.menu[5].count = response.data.myevents;
			this.menu[6].count = response.data.mychamps;
		});
	}

	showHelper() { // Auxiliar para los menus que siempre son visibles (por ejemplp, HOME o DOWNLOADS)
		return true;
	}

	SetLang(lang) {
		this.translate.use(lang);
	}

	GetLang() {
		return this.translate.use();
	}

	OnMenuClick()
	{
		this.isCollapsed = true;
	}
}

// https://docs.angularjs.org/guide/component
export default angular.module('directives.navbar', [])
	.component('navbar', {
		template: require('./navbar.html'),
		controller: NavbarComponent,
		controllerAs: 'nav'
	})
	.name;



// WEBPACK FOOTER //
// ./client/components/navbar/navbar.component.js